import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";

import { useStyles } from "./TeacherTimeTable.css";
import AdminHeader from "../../../../Components/NavBar/Admin/AdminHeader/AdminHeader";
import Axios from "axios";
import { url } from "../../../../Config/Config";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import TeacherForm from "./TeacherForm/TeacherForm";
import CustomEmptyMessage from "../../../../Components/CustomEmptyMessage/CustomEmptyMessage";
import TimeTableTeacherDetails from "./TimeTableTeacherDetails/TimeTableTeacherDetails";
import { getAdminRefreshToken } from "../../../../Redux/Actions/actions";
import PageTitle from "../../../../Components/PageTitle/PageTitle";
import CustomBreadCrumbs from "../../../../Components/CustomBreadCrumbs/CustomBreadCrumbs";

class TeacherTimeTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timeList: [],
      data: {
        teacherName: "",
      },
      teacherTimeList: [],
    };
  }

  componentDidMount() {
    this.getTimeTable();
  }

  getTimeTable = async () => {
    try {
      const response = await Axios.get(`${url}/api/time-tables`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.timeTables.length !== 0) {
        this.setState({
          timeList: response.data.timeTables,
          isEmpty: false,
        });
      } else {
        this.setState({
          timeList: [],
          isEmpty: true,
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getTimeTable();
      }
    }
  };

  handleChange = (e) => {
    let timeData = [];
    for (let i = 0; i <= this.state.timeList.length - 1; i++) {
      for (let j = 0; j <= this.state.timeList[i].times.length - 1; j++) {
        for (
          let k = 0;
          k <= this.state.timeList[i].times[j].subjects.length - 1;
          k++
        ) {
          if (e.target.value === "") {
            timeData = [];
          } else if (
            this.state.timeList[i].times[j].subjects[k].classTeacherId ===
            e.target.value
          ) {
            this.state.timeList[i].faculty && this.state.timeList[i].group
              ? timeData.push({
                  studentClass: this.state.timeList[i].studentClass,
                  faculty: this.state.timeList[i].faculty,
                  group: this.state.timeList[i].group,
                  section: this.state.timeList[i].section,
                  weekName: this.state.timeList[i].times[j].weekName,
                  subjectName:
                    this.state.timeList[i].times[j].subjects[k].subjectName,
                  from: this.state.timeList[i].times[j].subjects[k].from,
                  to: this.state.timeList[i].times[j].subjects[k].to,
                  classTeacherName:
                    this.state.timeList[i].times[j].subjects[k]
                      .classTeacherName,
                })
              : timeData.push({
                  studentClass: this.state.timeList[i].studentClass,
                  section: this.state.timeList[i].section,
                  weekName: this.state.timeList[i].times[j].weekName,
                  subjectName:
                    this.state.timeList[i].times[j].subjects[k].subjectName,
                  from: this.state.timeList[i].times[j].subjects[k].from,
                  to: this.state.timeList[i].times[j].subjects[k].to,
                  classTeacherName:
                    this.state.timeList[i].times[j].subjects[k]
                      .classTeacherName,
                });
          }
        }
      }
    }
    this.setState({
      data: { ...this.state.data, [e.target.name]: e.target.value },
      teacherTimeList: timeData.length !== 0 ? timeData : [],
    });
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <AdminHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />

          <CustomBreadCrumbs url={this.props.match.url} />
          <PageTitle
            title="Teacher's TimeTable"
            refreshUrl={this.props.match.url}
          />
          <TeacherForm
            data={this.state.data}
            handleChange={this.handleChange}
          />
          <br />
          {this.state.teacherTimeList.length !== 0 ? (
            <Grid container spacing={3}>
              {this.state.teacherTimeList.map((timeData, index) => (
                <TimeTableTeacherDetails key={index} timeData={timeData} />
              ))}
            </Grid>
          ) : (
            <CustomEmptyMessage description="Select Above Teacher" />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    isAdmin: state.AdminReducer.isAdmin,
    role: state.AdminReducer.role,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(TeacherTimeTable)));
